module.exports = {
  OVERDUE: { api: 'OVERDUE', human: 'Überfällig' },
  DUE: { api: 'DUE', human: 'Heute fällig' },
  DONE: { api: 'DONE', human: 'Erledigt' },
  SCHEDULED: { api: 'SCHEDULED', human: 'Geplant' }
}
